import styled from 'styled-components'

export const CopyButton = styled.button`
  border: none;
  background: ${({ theme }) => theme.colors.mainBlue1000};
  font-weight: bold;
  cursor: pointer;
  color: white;
  padding: 1rem;
  cursor: pointer;
  width: 10rem;
  position: absolute;
  right: 2rem;
  top: 5rem;
  &:hover {
    background: ${({ theme }) => theme.colors.mainBlue500};
  }
`
